import React from 'react'

function NotFound() {
    return (
        <div>
            Oops... That page does not exist!
        </div>
    )
}

export default NotFound
